import dateformat from 'dateformat'
export const getSheetHeader=(BuyerInfo,SellerInfo)=>{
  const row_0=new Array(9),row_1=new Array(9),row_2=new Array(9),row_3=new Array(9), sheetHeader=new Array()

  //第一行
  for(let i=0;i<=8;i++){
    if(i==0){
      row_0[i]={
        v: '工业品购销合同',
      }
    }else{
      row_0[i]={
        v: '',
      }
    }
  }
  //第一行
  for(let i=0;i<=8;i++){
    if(i==0){
      row_1[i]={
        v: '买方',
      }
      row_2[i]={
        v: '卖方',
      }
      row_3[i]={
        v: '一、产品名称、描述、单位、数量、金额和供货期',
      }
    }else if(i==2){
      row_1[i]={
        v: BuyerInfo.name||'',
      }
      row_2[i]={
        v: SellerInfo.fullname||'',
      }
      row_3[i]={
        v: '',
      }
    }else if(i==4){
      row_1[i]={
        v: '合同编号',
      }
      row_2[i]={
        v: '签定时间/地点',
      }
    }else if(i==6){
      row_1[i]={
        v: "FT-"+ dateformat(new Date(), "yyyymmddHHMM"),
      }
      row_2[i]={
        v: dateformat(new Date(), "yyyy-mm-dd")+'/青岛',
        t: 's',
      }
      row_3[i]={
        v: '',
      }
    }else{
      row_1[i]={
        v: '',
      }
      row_2[i]={
        v: '',
        t: 's',
      }
      row_3[i]={
        v: '',
      }
    }
  }
  const row_4=[ '序号','名称','规格描述','单位','数量','单价','合计','供货期','备注']
  sheetHeader.unshift(row_4)
  sheetHeader.unshift(row_3)
  sheetHeader.unshift(row_2)
  sheetHeader.unshift(row_1)
  sheetHeader.unshift(row_0)

  return sheetHeader
}
